// extracted by mini-css-extract-plugin
module.exports = {"container":"requestcard_container__1tGz7","informationContainer":"requestcard_informationContainer__59q-l"};